export const ABRAFIPA_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/logo-slogan.png",
    "contentUrl": "https://everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/selo-ABRAFIPA#webpage",
   "url": "https://everest.ind.br/pt/selo-ABRAFIPA",
   "name": "Selo ABRAFIPA | Everest",
   "description": "A Everest possui o Selo ABRAFIPA, certificação que atesta a qualidade e conformidade dos purificadores de água com as normas da Associação Brasileira de Fabricantes e Importadores de Produtos de Purificação de Água.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/selo-ABRAFIPA#breadcrumb"
   },
   "primaryImageOfPage": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/selo-abrafipa.jpg"
   }
  },
  {
   "@type": "AboutPage",
   "@id": "https://everest.ind.br/pt/selo-ABRAFIPA#aboutpage",
   "url": "https://everest.ind.br/pt/selo-ABRAFIPA",
   "name": "Selo ABRAFIPA | Everest",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/selo-ABRAFIPA#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Selo ABRAFIPA",
     "item": "https://everest.ind.br/pt/selo-ABRAFIPA"
    }
   ]
  }
 ]
}
